export default "__VITE_ASSET__CUHyiL3B__"